import { render, staticRenderFns } from "./EconomicPerformance.vue?vue&type=template&id=5545fb1f&scoped=true"
import script from "./EconomicPerformance.vue?vue&type=script&lang=js"
export * from "./EconomicPerformance.vue?vue&type=script&lang=js"
import style0 from "./EconomicPerformance.vue?vue&type=style&index=0&id=5545fb1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545fb1f",
  null
  
)

export default component.exports